import { App } from 'App';
import React from 'react';
import ReactDOM from 'react-dom';
import './_index.scss';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { api } from 'api';

const { rootReducer } = require('./reducers');
const { initialize } = require('./actions/initializers');

const composeEnhancers = process.env.NODE_ENV === 'production'
  ? compose
  : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk.withExtraArgument({ api }))),
);

store.dispatch(initialize(store));

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
      <Route component={App} />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);

if (module.hot) {
  module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
}
